
import { requireValidator, getVuetifyValidator } from '@/utils/validators/index'
import defaultParser from '../parsers/base_parser'

export default {

  /**
   *
   *
   */
  props: {

    // Входные данные
    data: {
      type: Object,
      required: true
    },

    // Необходимо для инициализации значения по умолчанию
    value: {

    },

    // Внешний парсер
    customParser: {
      type: Object,
      required: false,
      default: null
    }
  },

  /**
   *
   *
   */
  data() {

    return {

      currentValue: null,

      // Текущий парсер (встроенный или внешний)
      parser: defaultParser,

      // Название поля
      name: ''
    }
  },

  /**
   *
   *
   */
  watch: {

    /**
     *
     *
     */
    value: {

      handler( value ) {

        this.currentValue = value
      },

      // Необходимо для инициализации значения по умолчанию
      immediate: true
    },

    /**
     * Изменение (замена / удаление) внешнего парсера.
     *
     */
     customParser: {

      handler: function () {

        // Инициализация компонента.
        this.init()
      },

      deep: true,
      immediate: true
    }
  },

  /**
   *
   *
   */
  computed: {

  },

  /**
   *
   *
   */
  methods: {

    /**
     *
     *
     * @param value
     */
    onInput( value ) {
      this.$emit( 'input', value )
    },

    /**
     * Инициализация парсера компонента.
     *
     * Если не задан (или имеет некорректный формат) внешний парсер,
     * подключается внутренний парсер (по умолчанию).
     *
     * Если парсер успешно подключен, возвращается true.
     * Иначе возвращается false.
     *
     */
    initParser( parser ) {

      if ( this.customParser === null ) {
        this.parser = parser ? parser : defaultParser
        return true
      }

      if ( this.checkParser() ) {
        this.parser = this.customParser
        return true
      }

      console.error( 'Парсер не подключен. Внешний парсер имеет некорректный формат.' )

      return false
    },

    /**
     * Проверка корректности структуры внешнего парсера.
     *
     * Если внешний парсер содержит все необходимые методы,
     * он подключается и возвращается true.
     * Иначе возвращается false.
     *
     */
    checkParser() {

      let isCustomParser = true

      // Проверка корректности структуры внешнего парсера
      // по аналогии со встроенным парсером.
      Object.keys( defaultParser ).forEach( ( method ) => {

        if ( typeof this.customParser[ method ] !== 'function' ) {
          console.error( `В парсере не найден метод ${method}` )
          isCustomParser = false
        }
      } );

      return isCustomParser
    },

    /**
     *
     *
     * @param validator
     * @param message
     * @returns {*}
     */
    validator( validator, message ) {
      return getVuetifyValidator( validator, message );
    },

    /**
     *
     *
     * @param value
     * @returns {*}
     */
    required( value ) {
      return requireValidator( value );
    }
  }
}



// WEBPACK FOOTER //
// ./src/apps/bpm/components/mixins/form_component.js